// extracted by mini-css-extract-plugin
export default {"footerPosts":"vKIUf","categoriesControls":"dTgJH"};